var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check-alt-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33464 12.8571L10.5346 14L13.3346 11.3333M2.66797 14C2.66797 11.4227 4.75731 9.33333 7.33464 9.33333C8.32613 9.33333 9.24541 9.64254 10.0013 10.1698M10.0013 4.66667C10.0013 6.13943 8.8074 7.33333 7.33464 7.33333C5.86188 7.33333 4.66797 6.13943 4.66797 4.66667C4.66797 3.19391 5.86188 2 7.33464 2C8.8074 2 10.0013 3.19391 10.0013 4.66667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowIcon);
export default __webpack_public_path__ + "static/media/followIcon.79ea09e7be76031f24b4817f6c4bb08f.svg";
export { ForwardRef as ReactComponent };